import styled from 'styled-components';
import colors from 'styles/colors';

export const Container = styled.div`
	display: flex;
	min-height: 200px;
    flex-direction: column;
    gap:5px;
    max-width: 260px;
`;

export const Row = styled.div<{ width?: number }>`
	display: flex;	
    width: ${props => props.width ? props.width+'px' : '100%' };
    height: 18px;
    background: ${colors.functional.loadingGrey};
    border-radius: 5px;
`;

export const Body = styled.div`
    display: flex;
    flex-direction: row;
    gap:5px;
    flex-wrap: wrap;
    align-content: flex-start;
    margin-top:10px;    
    width: 100%;
    justify-content: space-between;
    
`;

export const Footer = styled.div<{ width?: number }>`
	display: flex;	
    height: 38px;
    background: ${colors.functional.loadingGrey};
    border-radius: 5px;
    margin-top:10px;
`;